// Detección del idioma que habla el orador a partir de la transcripción del original. Sin servicios externos:
// cuenta palabras funcionales exclusivas de cada idioma. Solo distingue entre los idiomas candidatos del evento.
const WORDS = {
  en: "the and of to is are was were this that with have has for you we they it on be as at from not but what which will would can our your their there here these those because about into more also very thank thanks".split(" "),
  es: "el los las una unos unas es son fue pero muy también esto eso ese esta estos estas hay gracias nosotros ustedes usted ellos porque cuando donde como más sobre entre desde hasta todos todo cada puede pueden tiene tienen hacer ser estar y del al".split(" "),
  pt: "os as uma uns umas são foi mas muito também isto isso esse essa estes estas há obrigado obrigada nós vocês você eles porque quando onde como mais sobre entre desde até todos todo cada pode podem tem têm fazer ser estar não então ele ela dos das é está estão".split(" "),
};
// Palabras que existen en dos idiomas no cuentan para ninguno.
const SHARED = new Set(Object.values(WORDS).flatMap((list) => list).filter((word, index, all) => all.indexOf(word) !== all.lastIndexOf(word)));
const EXCLUSIVE = Object.fromEntries(Object.entries(WORDS).map(([code, list]) => [code, new Set(list.filter((word) => !SHARED.has(word)))]));

export const MIN_WORDS = 6;

// Devuelve el idioma ganador o null si no hay evidencia suficiente.
export function detectLanguage(text, candidates) {
  const words = String(text).toLowerCase().match(/[a-zà-ÿ]+/g) ?? [];
  if (words.length < MIN_WORDS) return null;
  const scores = {};
  for (const code of candidates) {
    if (!EXCLUSIVE[code]) continue;
    let score = words.reduce((total, word) => total + (EXCLUSIVE[code].has(word) ? 1 : 0), 0);
    if (code === "es" && /ñ|¿|¡/.test(text)) score += 2;
    if (code === "pt" && /[ãõç]/.test(text)) score += 2;
    scores[code] = score;
  }
  const ranked = Object.entries(scores).sort((a, b) => b[1] - a[1]);
  if (!ranked.length) return null;
  const [best, second] = [ranked[0], ranked[1] ?? ["", 0]];
  // Hace falta un mínimo de coincidencias y una ventaja clara sobre el segundo.
  return best[1] >= 2 && best[1] >= second[1] * 2 ? best[0] : null;
}
